import {
  SelectionActionPill,
  type SelectionAnchorRect,
} from "@cohesive/ui-components";

type FileRecordSelectionActionOverlayProps = {
  selectedText: string;
  anchorRect: SelectionAnchorRect | null;
  onActivate: (selectedText: string) => void;
  onClear?: () => void;
};

export function FileRecordSelectionActionOverlay({
  selectedText,
  anchorRect,
  onActivate,
  onClear,
}: FileRecordSelectionActionOverlayProps) {
  if (!selectedText || !anchorRect) return null;

  return (
    <SelectionActionPill
      anchorRect={anchorRect}
      onClick={() => {
        onActivate(selectedText);
        onClear?.();
      }}
    />
  );
}
